import React, { PureComponent } from 'react'
import { Alert } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import {
  getAllNotifications,
  getImportanceNotifications,
  getNotifications,
  makeReadNotification,
  makeUnreadNotification,
} from '../../actions/notifications'
import {
  disableNotificationsSort,
  enableNotificationsSort,
  NOTIFICATIONS_TABLE_SORT_IMPORTANCE,
  NOTIFICATIONS_TABLE_SORT_STATE,
  NOTIFICATIONS_TABLE_SORT_TYPE,
} from '../../actions/notifications_table_sort'
import { CustomPagination } from '../../components/common/custom_pagination/custom_pagination'
import DropDownFilter from '../../components/common/dropdown_filter'
import PageSizeFilter from '../../components/common/page_size_filter'
import { DivContentBox, DivTitleBox } from '../../components/common/styled'
import { Toolbar, ToolbarItem } from '../../components/common/toolbar/toolbar'
import Spinner3Bounce from '../../components/spinner_3_bounce'
import { SORT_ORDER_ASC, SORT_ORDER_DESC } from '../../config'
import SortData from '../../models/sort_data'

import { addToSearch, getActivePage, getSearchParams } from '../../utils/helpers'
import { getSortDirection } from '../../utils/sort'
import NotificationsTable from './notifications-table'

import SearchBar from './search_bar'
import './styles.scss'

const allImportanceStates = ['info', 'warning', 'critical']
const messageImportanceDefaultState = 'Importance: No Filter'

const allStates = ['read', 'unread'].sort()
const defaultStates = 'Status: No Filter'

const allIMessageTypeStates = ['Recent news', 'Roadmap updates', 'Outages', 'Hotfixes', 'Changelog'].sort()
const messageTypeDefaultState = 'Message Type: No Filter'

const pageSize = 20

const tableState = {
  filter: {
    [NOTIFICATIONS_TABLE_SORT_IMPORTANCE]: null,
    search: '',
    state: null,
    pageSize,
  },
  ordering: null,
  selected: [],
}

class Notifications extends PureComponent {
  static recordsPerPage = pageSize

  state = {
    filter: {
      [NOTIFICATIONS_TABLE_SORT_IMPORTANCE]: null,
      search: '',
      state: null,
      pageSize: Notifications.recordsPerPage,
    },
    ordering: null,
    selected: [],
    showImportance: false,
  }

  constructor(props) {
    super(props)
    const { state, search, ordering, importance, type } = getSearchParams()
    const { filter } = tableState

    this.state = {
      filter: {
        ...filter,
        ...{
          state,
          [NOTIFICATIONS_TABLE_SORT_IMPORTANCE]: importance,
          [NOTIFICATIONS_TABLE_SORT_TYPE]: type,
          search: search || '',
        },
      },
      ordering,
      selected: [],
    }
  }

  componentDidMount() {
    const { state, props } = this
    const { getNotifications, location, enableNotificationsSort } = props
    const { ordering, filter } = state
    let sortData

    if (ordering) {
      const field = ordering.indexOf('-') === 0 ? ordering.substring(1) : ordering
      const sortOrder = ordering.indexOf('-') === 0 ? SORT_ORDER_DESC : SORT_ORDER_ASC
      enableNotificationsSort(field, sortOrder)
      sortData = new SortData(field, sortOrder)
    }

    getNotifications(getActivePage(location), filter.pageSize, filter, sortData)
  }

  goTo = async (item) => {
    const { props } = this
    if (item.state !== 'read' && item.state !== 'pending') {
      await props.makeReadNotification(item.id)
      await props.getNotifications()
      props.getAllNotifications()
    }
    props.navigateToIdentity(item.id)
  }

  handleSelectPage = (page) => {
    if (page === getActivePage(this.props.location)) {
      return
    }
    this.search(page)
  }

  search = (page, sortData) => {
    const { props, state } = this
    const { navigateToPage, getNotifications } = props
    const { filter } = state
    let searchString = `?page=${page || getActivePage(props.location)}`
    const { search } = filter
    if (search) {
      searchString = addToSearch(searchString, `search=${search}`)
    }

    if (filter.state && filter.state !== 'All') {
      searchString = addToSearch(searchString, `state=${filter.state}`)
    }

    if (filter[NOTIFICATIONS_TABLE_SORT_IMPORTANCE] && filter[NOTIFICATIONS_TABLE_SORT_IMPORTANCE] !== 'All') {
      searchString = addToSearch(searchString, `importance=${filter[NOTIFICATIONS_TABLE_SORT_IMPORTANCE]}`)
    }

    if (filter[NOTIFICATIONS_TABLE_SORT_TYPE] && filter[NOTIFICATIONS_TABLE_SORT_TYPE] !== 'All') {
      searchString = addToSearch(searchString, `type=${filter[NOTIFICATIONS_TABLE_SORT_TYPE]}`)
    }

    if (sortData) {
      const { field, order } = sortData
      if (field && order) {
        searchString = addToSearch(searchString, `ordering=${order === 'asc' ? field : `-${field}`}`)
      }
    }
    getNotifications(page, filter.pageSize, filter, sortData)
    navigateToPage('', searchString || '')
  }

  handleTableSort = (field) => {
    const { props } = this
    const { sortField, sortOrder, enableNotificationsSort, disableNotificationsSort } = props
    const sortDirection = getSortDirection(sortOrder, sortField, field)
    if (sortDirection) {
      enableNotificationsSort(field, sortDirection)
    } else {
      disableNotificationsSort()
      field = null
    }
    this.search(getActivePage(props.location), new SortData(field, sortDirection))
  }

  handleChange = (item) => {
    let selected = [...this.state.selected]
    if (selected.map((i) => i.id).includes(item.id)) {
      selected = selected.filter((i) => i.id !== item.id)
    } else {
      selected.push(item)
    }
    this.setState({ selected })
  }
  updateFilter = (event) => {
    const { state, props } = this
    const { sortField, sortOrder } = props
    const filter = { ...state.filter, ...event }
    this.setState({ filter }, () => this.search(1, new SortData(sortField, sortOrder)))
  }

  updatePageSizeFilter = (event) => {
    const { state, props } = this
    const { sortField, sortOrder } = props
    const filter = { ...state.filter, ...event }
    this.setState({ filter }, () => this.search(1, new SortData(sortField, sortOrder)))
  }

  makeRead = async () => {
    const { props, state } = this
    const { getAllNotifications, makeReadNotification, sortOrder, sortField, field } = props
    const sortDirection = getSortDirection(sortOrder, sortField, field)

    try {
      await Promise.all(
        state.selected
          .filter((i) => i.state !== 'read' && i.state !== 'pending')
          .map(async (i) => await makeReadNotification(i.id))
      )
    } catch (e) {
      console.log(e)
    }
    this.setState({ selected: [] })
    this.search(getActivePage(props.location), new SortData(field, sortDirection))
    getAllNotifications()
  }

  makeUnread = async () => {
    const { props, state } = this
    const { getAllNotifications, makeUnreadNotification, sortOrder, sortField, field } = props
    const sortDirection = getSortDirection(sortOrder, sortField, field)

    try {
      await Promise.all(
        state.selected.filter((i) => i.state === 'read').map(async (i) => await makeUnreadNotification(i.id))
      )
    } catch (e) {
      console.log(e)
    }
    this.setState({ selected: [] })
    this.search(getActivePage(props.location), new SortData(field, sortDirection))
    getAllNotifications()
  }

  setImportance = async () => {
    await this.resetFilter()
    this.setState({ showImportance: true }, () => {
      const { state } = this
      if (this.state.showImportance) {
        const filter = { ...state.filter, ...{ [NOTIFICATIONS_TABLE_SORT_IMPORTANCE]: 'warning' } }
        this.setState({ filter }, () => this.search(1))
      } else {
        this.search(1)
      }
    })
  }
  setDefault = async () => {
    await this.resetFilter()
    this.setState({ showImportance: false }, () => {
      const { state } = this
      const filter = { ...state.filter, ...{ [NOTIFICATIONS_TABLE_SORT_IMPORTANCE]: '' } }
      this.setState({ filter }, () => this.search(1))
    })
  }

  resetFilter = () => {
    return new Promise((resolve) => {
      const { state } = this

      const filter = {
        [NOTIFICATIONS_TABLE_SORT_IMPORTANCE]: null,
        search: '',
        state: null,
        pageSize: state.filter.pageSize,
      }
      const ordering = null
      const selected = []

      this.setState({ selected, ordering, filter }, () => resolve())
    })
  }

  render() {
    const { props, state } = this
    const { errorMessage, isFetching, results, sortField, sortOrder } = props
    if (isFetching || !results) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }

    return (
      <div className='animated fadeIn'>
        <DivTitleBox className='ibox-title'>
          <div className='row'>
            <Toolbar columns={5}>
              <ToolbarItem>
                <SearchBar updateFilter={this.updateFilter} searchTerm={state.filter.search} />
              </ToolbarItem>
              <ToolbarItem>
                <DropDownFilter
                  filterName={NOTIFICATIONS_TABLE_SORT_TYPE}
                  z
                  defaultValue={messageTypeDefaultState}
                  values={allIMessageTypeStates}
                  filter={state.filter[NOTIFICATIONS_TABLE_SORT_TYPE]}
                  updateFilter={this.updateFilter}
                />
              </ToolbarItem>

              <ToolbarItem>
                <DropDownFilter
                  filterName={NOTIFICATIONS_TABLE_SORT_IMPORTANCE}
                  defaultValue={messageImportanceDefaultState}
                  values={allImportanceStates}
                  filter={state.filter[NOTIFICATIONS_TABLE_SORT_IMPORTANCE]}
                  updateFilter={this.updateFilter}
                />
              </ToolbarItem>
              <ToolbarItem>
                <DropDownFilter
                  filterName={NOTIFICATIONS_TABLE_SORT_STATE}
                  defaultValue={defaultStates}
                  values={allStates}
                  filter={state.filter.state}
                  updateFilter={this.updateFilter}
                />
              </ToolbarItem>
              <ToolbarItem>
                <PageSizeFilter updateFilter={this.updatePageSizeFilter} filter={parseInt(state.filter.pageSize)} />
              </ToolbarItem>
            </Toolbar>
          </div>
        </DivTitleBox>

        <DivContentBox className='ibox'>
          <div>{errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}</div>
          <div className='ibox-content round-corner-box-bottom'>
            <div className='row'>
              <div className='col-md-12 notification-table'>
                <ul className='nav nav-tabs'>
                  <li className={`${!state.showImportance ? 'active' : ''}`} onClick={() => this.setDefault()}>
                    <span className={'text-link'}>
                      <i className='fa fa-inbox' style={{ marginRight: 10 }} />
                      All
                    </span>
                  </li>
                  <li className={`${state.showImportance ? 'active' : ''}`} onClick={() => this.setImportance()}>
                    <span className={'text-link'}>
                      <i className='fa fa-exclamation' style={{ marginRight: 10 }} />
                      Importance
                    </span>
                  </li>
                </ul>
                <div className='tab-content'>
                  <div className='tab-pane active'>
                    <div className='list-group'>
                      <>
                        <NotificationsTable
                          selected={state.selected}
                          handleChange={this.handleChange}
                          sortOrder={sortOrder}
                          sortField={sortField}
                          results={results}
                          goTo={this.goTo}
                          handleTableSort={this.handleTableSort}
                        />
                        <div className='row' style={{ textAlign: 'right' }}>
                          <div className='col-md-12'>
                            <button
                              type='button'
                              className='btn btn-default'
                              disabled={state.selected.length === 0}
                              onClick={this.makeRead}
                            >
                              Mark As Read
                            </button>{' '}
                            &nbsp;
                            <button
                              type='button'
                              className='btn btn-default'
                              disabled={state.selected.length === 0}
                              onClick={this.makeUnread}
                            >
                              Mark As Unread
                            </button>
                          </div>
                        </div>

                        <div className='text-center'>
                          <CustomPagination
                            activePage={getActivePage(props.location)}
                            onPageChanged={this.handleSelectPage}
                            totalRecords={results.count}
                            pageLimit={state.filter.pageSize}
                          />
                        </div>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DivContentBox>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  errorMessage: state.getNotifications.errorMessage,
  results: state.getNotifications.results,
  isFetching: state.getNotifications.isFetching,
  pageHash: ownProps.location.hash,
  navigateToPage: (p, s) => ownProps.history.push({ pathname: '/notifications', search: s || '' }),
  navigateToIdentity: (id) => ownProps.history.push(`/notifications/${id}`),
  sortField: state.notificationsSort.sortField,
  sortOrder: state.notificationsSort.order,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getNotifications,
      makeReadNotification,
      makeUnreadNotification,
      enableNotificationsSort,
      disableNotificationsSort,
      getAllNotifications,
      getImportanceNotifications,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notifications))
